<template>
	<v-layout wrap class="container company-data">
		<v-flex md5 xs12>
			<div class="mb-5">
				<a href="">
					<img
						v-if="isJapi"
						src="/static/images-new/sections/logo-japi.svg" 
						alt="CasaMarket"
						class="logo">
					<img
						v-else
						src="/static/images-new/logos/logo-casamarket.svg" 
						alt="CasaMarket"
						class="logo">	
				</a>
			</div>
			<div class="layout">
				<a :href="isJapi ? linkInstagramJapi : linkInstagram" class="mr-3" target="_blank" v-if="!isJapi">
					<img src="/static/images-new/logos/logo-instagram.svg" alt="instagram">
				</a>
				<a :href="isJapi ? linkYoutubeJapi : linkYoutube" target="_blank" class="mr-3">
					<img src="/static/images-new/logos/logo-youtube.svg" alt="youtube">
				</a>
				<a :href="isJapi ? linkFbJapi : linkFb" target="_blank" class="mr-3">
					<img src="/static/images-new/logos/logo-facebook.svg" alt="facebook">
				</a>
			</div>
		</v-flex>
		<v-flex md7 xs12 class="wrapper-information">
			<v-layout wrap>
				<v-flex md4 xs12 pr-3 class="text-information" v-if="!isJapi">
					<p class="title w-bold">Empresa</p>
					<ul class="list-company">
						<li class="mb-2">
							<a href="/market-place" target="_blank" class="link-social-networks">Quiero comprar</a>
						</li>
						<li>
							<a href="https://quierovender.casamarket.la/"  target="_blank" class="link-social-networks">Quiero vender</a>
						</li>
					</ul>
				</v-flex>
				<v-flex 
					v-for="country in countries"
					:key="country.name"
					md4
					xs12
					pr-3
					class="text-information">
					<p
						:class="[ isJapi ? 'title-japi' : 'title']"
						class="w-bold">
						{{ country.name }}
					</p>
					<p class="mb-0 w-bold mb-2">{{ country.city }}</p>
					<div>
						<div 
							v-for="phone in country.phones" 
							:key="phone"
							v-html="phone">
						</div>
					</div>
				</v-flex>
			</v-layout>
		</v-flex>
	</v-layout>
</template>
<script>

function data() {
	return {
		countries: [
			{
				name: 'Perú',
				city: 'Lima',
				phones: [
					`${process.env.PHONE !== '' ? `${process.env.PHONE} </br>` : ''}
					Calle Independencia  106,</br>  
					Piso 10 Miraflores`,
				],
			},
			{
				name: 'Ecuador',
				city: 'Latacunga',
				phones: [
					`${process.env.PHONE_ECU}</br>
					AV.UNIDAD NACIONAL Y GABRIELA MISTRAL. EDIF FENIX CORP</br>
					Matriz Centro Tecnológico Latacunga`,
				],
			},
		],
		linkInstagram: process.env.LINK_INSTAGRAM,
		linkYoutube: process.env.LINK_YOUTUBE,
		linkFb: process.env.LINK_FACEBOOK,
		linkInstagramJapi: process.env.LINK_INSTAGRAM_JAPI,
		linkYoutubeJapi: process.env.LINK_YOUTUBE_JAPI,
		linkFbJapi: process.env.LINK_FACEBOOK_JAPI,
	};
}

export default {
	name: 'company-data',
	data,
	props: {
		isJapi: {
			type: Boolean,
			default: false,
		},
	},
};
</script>
<style lang="scss" scoped>
	.company-data {
		color: color(newwarning);
		font-size: 16px;
		padding: 98px 5%;

		@media (max-width: 900px) {
			padding: 71px 53px 25px 53px;
		}
	}

	.title {
		color: color(newprimary);
		font-size: size(large24);
	}

	.title-japi {
		color: color(blue-japi);
		font-size: size(large24);
	}

	.list-company {
		list-style: none;
	}

	.link-social-networks {
		color: color(newwarning);
		text-decoration: none;
	}

	.logo {
		@media (max-width: 900px) {
			height: 57px;
			max-width: 100%;
		}
	}

	.wrapper-information {
		@media (max-width: 900px) {
			margin-top: 48px;
		}
	}

	.text-information {
		@media (max-width: 900px) {
			margin-bottom: 43px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/home-new/company-data.vue